import { CategorySelectionItem } from "./category_selection_item";
import { CategorySelectionItemPrice } from "./category_selection_item_price";

export const CategorySelectionItems = (props) => {
  const changeSelectionText = "Změnit výběr";

  let tableStyle = { display: "block" };

  if (props.loadingInProgress) {
    tableStyle["pointerEvents"] = "none";
    tableStyle["cursor"] = "default";
  }

  return (
    <table id="category-selection-items" style={tableStyle}>
      <tbody>
        <tr>
          {props.items.map((item, i) => (
            <CategorySelectionItem
              item={item[1]}
              key={item.id || i}
              type={item[0]}
              handleClick={handleClick}
              removeFromCategorySelection={props.removeFromCategorySelection}
              removeImageUrl={props.removeImageUrl}
            />
          ))}
        </tr>
        <tr>
          {props.items.map((item, i) => (
            <CategorySelectionItemPrice
              item={item[1]}
              key={i * 100}
              handleClick={handleClick}
            />
          ))}
        </tr>

        <tr id="menu">
          <td
            className={
              props.selectedCategory == "ovens" ? "link active" : "link"
            }
            onClick={() => handleClick("ovens")}
          >
            {"Vestavná trouba"}
          </td>
          <td
            className={
              props.selectedCategory == "hobs" ? "link active" : "link"
            }
            onClick={() => handleClick("hobs")}
          >
            {"Varná deska"}
          </td>
          <td
            className={
              props.selectedCategory == "dishwashers" ? "link active" : "link"
            }
            onClick={() => handleClick("dishwashers")}
          >
            {"Myčka nádobí"}
          </td>
          <td
            className={
              props.selectedCategory == "microwaves" ? "link active" : "link"
            }
            onClick={() => handleClick("microwaves")}
          >
            {"Mikrovlnná trouba"}
          </td>
          <td
            className={
              props.selectedCategory == "extractors" ? "link active" : "link"
            }
            onClick={() => handleClick("extractors")}
          >
            {"Odsavač par"}
          </td>
          <td
            className={
              props.selectedCategory == "fridges" ? "link active" : "link"
            }
            onClick={() => handleClick("fridges")}
          >
            {"Lednička"}
          </td>
        </tr>
      </tbody>
    </table>
  );

  function handleClick(tabName) {
    $("html, body").animate({
      scrollTop: $("#step-1-headline").offset().top - 35,
    });
    props.changeTab(tabName);
    props.loadCategory(tabName);
  }
};
